/**
 * Универсальный тип для определения типа модератора
 */
type ModeratorLike = {
    type?: 'USER' | 'GUEST';
    userId?: string | null;
    identity?: string | null;
};

/**
 * Определяет тип модератора на основе его полей
 * Работает как с RoomModerator (парсированный), так и с RoomModeratorRaw (сырой)
 * Приоритет: явный тип > определение по полям (userId -> USER, identity -> GUEST)
 */
export const determineModeratorType = (moderator: ModeratorLike | null | undefined): 'USER' | 'GUEST' | null => {
    if (!moderator || typeof moderator !== 'object') {
        return null;
    }

    const moderatorType = moderator.type;
    const moderatorUserId = moderator.userId ?? null;
    const moderatorIdentity = moderator.identity ?? null;

    if (moderatorType === 'USER' || moderatorType === 'GUEST') {
        return moderatorType;
    }

    if (moderatorUserId != null) {
        return 'USER';
    }

    if (moderatorIdentity != null) {
        return 'GUEST';
    }

    return null;
};
